import React, { useMemo } from 'react';
import { Calendar } from '../ui/calendar';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const MODIFIERS_STYLES = {
  booked: { backgroundColor: '#C9A961', color: 'white', fontWeight: 'bold' },
  blocked: { backgroundColor: '#EF4444', color: 'white', textDecoration: 'line-through' },
};

export const CalendarPanel = ({
  selectedDate,
  currentMonth,
  setCurrentMonth,
  onDateSelect,
  bookedDates,
  blockedDates,
}) => {
  const modifiers = useMemo(
    () => ({ booked: bookedDates, blocked: blockedDates }),
    [bookedDates, blockedDates]
  );

  return (
    <Card className="border-2 border-[#8B7355]/20">
      <CardHeader>
        <CardTitle className="font-serif text-2xl text-[#8B7355]">
          {currentMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Calendar
          mode="single"
          selected={selectedDate}
          onSelect={onDateSelect}
          month={currentMonth}
          onMonthChange={setCurrentMonth}
          className="rounded-md border-[#8B7355]/20"
          modifiers={modifiers}
          modifiersStyles={MODIFIERS_STYLES}
        />

        <div className="mt-6 flex gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded bg-[#C9A961]"></div>
            <span className="text-[#8B7355]">Booked</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded bg-red-500"></div>
            <span className="text-[#8B7355]">Blocked</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded border-2 border-[#8B7355]/20"></div>
            <span className="text-[#8B7355]">Available</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
